<template>
  <div class="tw:bg-blue-50 tw:border tw:border-blue-200 tw:rounded-xl tw:p-5">
    <h1 class="tw:font-bold tw:text-base tw:text-gray-900 tw:mb-3">
      {{ $t('pro_plus_header') }}
    </h1>

    <ul class="tw:flex tw:flex-col tw:gap-y-1.5 tw:mb-4 tw:list-disc tw:pl-5">
      <li v-for="item in features" :key="item" class="tw:gap-2 tw:text-sm tw:text-gray-700">
        {{ $t(item) }}
      </li>
    </ul>

    <!-- Pricing -->
    <div v-if="isPriceLoading" class="tw:h-8 tw:flex tw:items-center tw:mb-2">
      <SmallDotLoader color="#15803d" />
    </div>
    <div v-else>
      <div class="tw:flex tw:flex-wrap tw:items-baseline tw:gap-x-1.5 tw:mb-0.5">
        <span class="tw:text-2xl tw:font-bold tw:text-green-700">{{ formatCurrency(plusMonthlyPrice) }}</span>
        <span v-if="isPricingComparison" class="tw:text-sm tw:text-gray-400 tw:line-through">
          {{ formatCurrency(proPrice, { divideBy100: false }) }}
        </span>
      </div>
      <p v-if="isPricingComparison && monthlySavings > 0" class="tw:text-sm tw:font-bold tw:text-green-700 tw:mb-0.5">
        {{
          $t('subscription_monthly_savings', {
            SavingsAmount: formatCurrency(monthlySavings, { divideBy100: false }),
          })
        }}
      </p>
      <i18n-t keypath="subscription_price" tag="p" class="tw:text-xs tw:text-gray-500">
        <template #SubscriptionPrice>{{ formatCurrency(annualPrice) }}</template>
      </i18n-t>
      <p class="tw:text-xs tw:text-gray-500 tw:mb-3">{{ $t('subscription_voucher_info') }}</p>
    </div>

    <button
      @click="$emit('reactivate')"
      class="tw:text-blue-700 tw:font-bold tw:text-sm tw:hover:underline tw:hover:text-blue-800 tw:cursor-pointer"
    >
      {{ $t('reactivate_plus_subscription_cta') }}
    </button>
  </div>
</template>

<script setup>
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'
import { useFormatting } from '@/composables/useFormatting'

defineProps({
  isPriceLoading: {
    type: Boolean,
    default: false,
  },
  plusMonthlyPrice: {
    type: Number,
    default: 0,
  },
  annualPrice: {
    type: Number,
    default: 0,
  },
  proPrice: {
    type: Number,
    default: 0,
  },
  isPricingComparison: {
    type: Boolean,
    default: false,
  },
  monthlySavings: {
    type: Number,
    default: 0,
  },
})

defineEmits(['reactivate'])

const features = [
  'business_studio_plus_benefit_1',
  'business_studio_plus_benefit_2',
  'business_studio_plus_benefit_3',
  'business_studio_plus_benefit_4',
]

const { formatCurrency } = useFormatting()
</script>
